export enum TurnType {
    NORMAL = '1001', //Normal
    RETAINER = '1002', // Retén
    RESERVE = '1003' // Reserva
}